import { ChevronRightIcon } from '@heroicons/react/24/outline'
import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { DeliveryGuy } from '../images';
import { useAnalytics } from '../hooks/use-analytics';

const OrderPurchased = () => {
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    // Track that user reached the order confirmation page
    trackEvent('order_confirmation_viewed');
  }, [trackEvent]);

  return (
    <section id="order-purchased my-4">
        <Container fluid>
            <Row className="bg-light justify-content-start mb-5">
                <h1 className="section-title mt-4 mb-2 fs-2" data-aos="fade-up">PURCHASE MESSAGE</h1>
                <span style={{fontSize: '.8rem'}} className='mb-4'>
                    <Link to="/" className='text-success'>Home</Link> 
                    <ChevronRightIcon width={12} height={12} className='text-success' /> 
                    <Link to="/shop" className='text-success'>Shop</Link> 
                    <ChevronRightIcon width={12} height={12} className='text-success' /> 
                    <small>purchase</small>
                </span>
            </Row>
        </Container>
        <Container  data-aos="fade-up">
            <Row>
              <Col xs={12} md={7} className='my-5 mt-2'>
                <h4 className='mb-4'>Hey There,</h4>
                <p className='mb-2' style={{ fontSize: '1rem', color: '#333' }}>Thank you for placing your order! We have sent you an email receipt.</p>
                <p className='mb-2' style={{ fontSize: '1rem', color: '#333' }}>The receipt covers the order details, the store handling the request and the contact person.</p>
                <p className='mb-2' style={{ fontSize: '1rem', color: '#333' }}>Kindly note that, we have also sent you a password reset email to activate your account.</p>
                <p className='mb-2' style={{ fontSize: '1rem', color: '#333' }}>This account grant you the ability to track your order status and provide feedback.</p>
                <p className='mb-2 mt-4' style={{ fontSize: '1rem' }}>Signed,</p>
                <p className='mb-2' style={{ fontSize: '1rem' }}>Easysauce's Team.</p>
              </Col>
              <Col xs={12} md={5} className='d-flex flex-column justify-content-start align-items-end'>
                <img src={DeliveryGuy} alt="" width='50%' />
              </Col>
            </Row>
        </Container>
    </section>
  )
}

export default OrderPurchased
